import React, { useEffect, useState } from "react";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import LoginFrom from "./components/LoginForm";
import { getClientDetails } from "../../utils";
import { loginUser, forgotPasswordUser } from "./authThunks";
import { useNavigate } from "react-router-dom";
// Replaced by management with the new navy/gold TRIAC-branded logo, used for
// every subscription type now. Not yet finalized -- the old per-subscription
// logos are backed up under assets/icons/_old-logos-backup/ if this needs
// reverting (old forthapps logo: forthgo.svg; old pharma logo: pharma.svg).
import forthappsLogo from "../../assets/icons/forthapps-logo.png";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoading, isAuthenticated, auth_info, error } = useSelector(state => state.auth);
  const [forgotLoading, setForgotLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated && auth_info) {
      const path = auth_info?.route_path;
      navigate(path);
    } else if (error) {
      message.error(error);
    }
  }, [isAuthenticated, auth_info, error, navigate])

  const [subscriptionType, subscriptionTypeSet] = useState("");
  const [appName, appNameSet] = useState("");
  const [appLogo, appLogoSet] = useState();

  useEffect(() => {
    let path = window.location.hostname;
 
    if (path === "erp.forthapps.com" || path === "erp-dev.forthapps.com") {
      subscriptionTypeSet("ForthERP");
      appNameSet("ForthERP");
      appLogoSet(forthappsLogo);
    } else if (
      path === "localhost" ||
      path === "pharmaerp.forthapps.com" ||
      path === "pharmaerp-dev.forthapps.com"
    ) {
      subscriptionTypeSet("PharmaERP");
      appNameSet("PharmaERP");
      appLogoSet(forthappsLogo);
    } else if (
      path === "pharmaacc.forthapps.com" ||
      path === "pharmaacc-dev.forthapps.com"
    ) {
      subscriptionTypeSet("PharmaBooks");
      appNameSet("Pharma Books");
      appLogoSet(forthappsLogo);
    } else if (
      path === "hrpayroll.forthapps.com" ||
      path === "hrpayroll-dev.forthapps.com"
    ) {
      subscriptionTypeSet("HRPayroll");
      appNameSet("HR-Payroll");
      appLogoSet(forthappsLogo);
    } else if (
      path === "accounts.forthapps.com" ||
      path === "accounts-dev.forthapps.com"
    ) {
      subscriptionTypeSet("ForthBooks");
      appNameSet("Forth Books");
      appLogoSet(forthappsLogo);
    } else {
      subscriptionTypeSet("ForthERP");
      appNameSet("ForthERP");
      appLogoSet(forthappsLogo); 
    }
  }, []);

  const onSubmit = async (values) => {
    const deviceDetails = await getClientDetails(); 
    const payload = {
      ...values,
      subscription_type: subscriptionType,
      device: deviceDetails,
    };
    dispatch(loginUser(payload));
  };

const onForgotSubmit = async (values, form, onSent) => {
  const email = values?.email?.trim();

  if (!email) {
    return message.warning("Email is required.");
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return message.warning("Invalid email address.");
  }

  setForgotLoading(true);
  const result = await dispatch(forgotPasswordUser(email));
  setForgotLoading(false);

  if (result.meta.requestStatus === "fulfilled") {
    message.success(result.payload);
    form?.resetFields();
    onSent?.();
  } else {
    message.error(result.payload);
  }
};


  return (
    <>
      <LoginFrom
        logo={appLogo}
        appName={appName}
        onSubmit={onSubmit}
        onForgotSubmit={onForgotSubmit}
        loginLoading={isLoading}
        forgotLoading={forgotLoading}
      />
    </>
  );
};

export default Login;
